import { FormControl, FormGroup } from '@angular/forms';
import { CODCollectedCleared } from 'src/app/core/models/reports/reports.model';
import { Options } from '../../../shared/report-format/report-format.constants';

export const CONSTS = {
  HEADER: $localize`COD Outstanding`,
  FROM_LABEL: $localize`From`,
  TO_LABEL: $localize`To`,
  DATE_LABEL: $localize`Date`,
};

export const FILE_NAME = 'COD-Outstanding-Report';

export const OUTSTANDING_PDF_REPORT = {
  NAME: 'COD Outstanding Report',
  HEADER: {
    LOCATION: 'Location:',
    TURN_IN: 'Turn In:',
  },
  FOOTER: {
    TOTAL_EXPECTED: 'Total Expected:',
    TURNED_IN: 'Total Turned In:',
  },
  COLUMNS: [
    'Driver'.toUpperCase(),
    'Loop'.toUpperCase(),
    'Trackno'.toUpperCase(),
    'Customer'.toUpperCase(),
    'City'.toUpperCase(),
    'Expected'.toUpperCase(),
    'CA/CH/C',
    'D/P',
    'TurnedIn'.toUpperCase(),
    'Comments'.toUpperCase(),
    'Date'.toUpperCase(),
    'LocationCode'.toUpperCase(),
  ],
  DATA_FIELDS: [
    'driver',
    'loop',
    'trackno',
    'customer',
    'city',
    'expected',
    'ca/ch/cc',
    'd/p',
    'turnedin',
    'comments',
    'date',
    'locationcode',
  ] as (keyof CODCollectedCleared)[],
};

type OutstandingReportField = {
  fromDate: FormControl<Date>;
  toDate: FormControl<Date>;
  reportFormat: FormControl<Options>;
};

export type OutstandingReportFormGroup =
  FormGroup<OutstandingReportField> | null;
